import * as Yup from 'yup';
import { consentLevelOptions } from './projectOptions';

export const emptyProject = () => ({
  type: 0,
  name: '',
  clientName: '',
  restriction: 0,
  target: '',
  description: '',
  industry: undefined,
  industryId: undefined,
  users: [],
});

const step1Schema = {
  type: Yup.number()
    .moreThan(0, 'Deal type is required')
    .required('Deal type is required'),
  clientName: Yup.string()
    .trim()
    .required('Client name is required')
    .max(256, 'Client name must be less than 256 characters'),
  name: Yup.string()
    .trim()
    .required('The project name is required')
    .max(256, 'The project name must be less than 256 characters'),
  target: Yup.string()
    .notRequired()
    .max(256, 'The target must be less than 256 characters'),
  description: Yup.string()
    .notRequired()
    .max(1000, 'The description must be less than 1000 characters'),
  restriction: Yup.number()
    .moreThan(0, 'Restriction is required')
    .required('Restriction is required'),
  consentLevel: Yup.string().oneOf(consentLevelOptions.map((opt) => opt.value)),
  industryId: Yup.string().required(),
};

export const projectSchemaStep1 = Yup.object().shape(step1Schema);

const User = Yup.object().shape({
  role: Yup.string().required(),
  email: Yup.string().required().email(),
});

const step2Schema = {
  users: Yup.array().of(User),
};

export const projectSchemaStep2 = Yup.object().shape(step2Schema);

export const projectSettingsSchema = Yup.object().shape({
  ...step1Schema,
  type: undefined,
});

export const getUserByRole = (project, role) => {
  if (project && project.users) {
    return (
      project.users.find((user) => {
        return !!user.roles.find(
          (r) => r.name === role && r.projectId === project.id
        );
      }) || {}
    );
  }
  return {};
};

export const getUserForList = (project, role) => {
  if (project[role]) {
    return project[role];
  }

  return {};
};

export const getUsersByRole = (project, role) => {
  if (project && project.users) {
    return (
      project.users.filter((user) => {
        return !!user.roles.find((r) => r.name === role);
      }) || []
    );
  }
  return [];
};
